import * as React from 'react';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const useCountdown = (deadline) => {
  // Time is in seconds
  const [time, setTime] = useState(
    Math.max(0, Math.floor((deadline.getTime() - Date.now()) / 1000))
  );

  const decrement = () =>
    setTime((prevTime) => {
      return prevTime === 0 ? 0 : prevTime - 1;
    });  
  useEffect(() => {
    const id = setInterval(decrement, 1000);
    return () => clearInterval(id);
  }, []);

  const format = (num) => {
    return num < 10 ? '0' + num : num.toString();
  };

  return {
    days: format(Math.floor(time / (3600 * 24))),
    hours: format(Math.floor((time / 3600) % 24)),
    minutes: format(Math.floor((time / 60) % 60)),
    seconds: format(time % 60),
  };
};

export default function TimerCounter({ onTimeUpdate}) {
  const hour = 0.3e6; // 1 Hour in milliseconds
  const numHours = 1; // Number of hours in the future
  const [deadline] = useState(new Date(Date.now() + numHours * hour));
  const time = useCountdown(deadline);

  // Callback function to pass time data to parent component
  useEffect(() => {
    onTimeUpdate && onTimeUpdate(time.minutes, time.seconds);
  }, [time.minutes, time.seconds, onTimeUpdate]);

  return null;
}

TimerCounter.propTypes = {
  onTimeUpdate: PropTypes.func.isRequired,
  useEffect:PropTypes.any
};